export default __webpack_public_path__ + "static/media/ReleaseNotes_Content_BrokerNotes4.9f131014.png";